import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  FormControl,
  CircularProgress,
} from '@material-ui/core';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import Actions from '../../store/ducks/userProfile';
import Logo from '../../components/Logo';
import useStyles from './styles';

const RecoveryPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const { emailSent } = useSelector(({ userProfile }) => userProfile);
  const [values, setValues] = useState({
    email: '',
  });
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleChange = useCallback((event, prop) => {
    const inputValue = event.target?.value;
    setValues(oldValues => ({ ...oldValues, [prop]: inputValue }));
  }, []);

  const handleClickBack = useCallback(() => {
    history.push('/');
  }, [history]);

  const handleSubmit = useCallback(
    e => {
      e.preventDefault();
      setLoading(true);
      if (!values.email) {
        return;
      }
      dispatch(Actions.recoverUserPassword(values.email));
    },
    [dispatch, values.email],
  );

  useEffect(() => {
    if (emailSent !== null) {
      setLoading(false);
      if (emailSent.status && emailSent.msg) {
        enqueueSnackbar(emailSent.msg, {
          variant: 'error',
        });
      } else if (emailSent === true) {
        enqueueSnackbar('Email de recuperação enviado', {
          variant: 'success',
        });
        setTimeout(() => {
          history.push('/');
        }, 3000);
      }
    }

    return () => {
      if (emailSent !== null) {
        dispatch(Actions.recoverUserPassword(null));
      }
    };
  }, [dispatch, emailSent, enqueueSnackbar, history]);

  return (
    <Box className={classes.container}>
      <Helmet>
        <title>Esqueci minha senha</title>
      </Helmet>
      <Box className="logo-container">
        <Logo className="logo-img" />
      </Box>
      <Box className="description-container">
        <Typography className="description" variant="body2">
          Informe seu e-mail de acesso para recuperar a senha:
        </Typography>
      </Box>
      <FormControl component="form" onSubmit={handleSubmit}>
        <Box className="input-container email">
          <TextField
            className="input"
            id="login-email"
            variant="outlined"
            type="email"
            label="Email"
            value={values.email}
            onChange={e => handleChange(e, 'email')}
          />
        </Box>
        <Box className="btn-recovery-container">
          <Button
            type="submit"
            className="btn-recovery"
            variant="contained"
            color="primary"
            size="large"
          >
            {loading ? (
              <CircularProgress
                className="btn-login-loading"
                color="inherit"
                size={24}
              />
            ) : (
              'Recuperar senha'
            )}
          </Button>
        </Box>
      </FormControl>
      <Box className="btn-back-container">
        <Button
          type="button"
          variant="text"
          color="secondary"
          size="large"
          onClick={handleClickBack}
        >
          Voltar
        </Button>
      </Box>
    </Box>
  );
};

export default RecoveryPassword;
